"use strict";

var _fontawesomeSvgCore = require("@fortawesome/fontawesome-svg-core");

var _faExclamationTriangle = require("@fortawesome/pro-solid-svg-icons/faExclamationTriangle");

var _faUser = require("@fortawesome/pro-solid-svg-icons/faUser");

var _faCalendarCheck = require("@fortawesome/pro-solid-svg-icons/faCalendarCheck");

var _faTimes = require("@fortawesome/pro-light-svg-icons/faTimes");

var _faInfo = require("@fortawesome/free-solid-svg-icons/faInfo");

var _faCaretDown = require("@fortawesome/free-solid-svg-icons/faCaretDown");

var _faCaretUp = require("@fortawesome/free-solid-svg-icons/faCaretUp");

var _faTh = require("@fortawesome/free-solid-svg-icons/faTh");

var _faQuestion = require("@fortawesome/free-solid-svg-icons/faQuestion");

var _faSearch = require("@fortawesome/free-solid-svg-icons/faSearch");

var _faStar = require("@fortawesome/free-solid-svg-icons/faStar");

var _faPlus = require("@fortawesome/free-solid-svg-icons/faPlus");

var _faMinus = require("@fortawesome/free-solid-svg-icons/faMinus");

var _faExpand = require("@fortawesome/free-solid-svg-icons/faExpand");

var _faLocationArrow = require("@fortawesome/free-solid-svg-icons/faLocationArrow");

_fontawesomeSvgCore.library.add(_faExclamationTriangle.faExclamationTriangle);

_fontawesomeSvgCore.library.add(_faUser.faUser);

_fontawesomeSvgCore.library.add(_faInfo.faInfo);

_fontawesomeSvgCore.library.add(_faTimes.faTimes);

_fontawesomeSvgCore.library.add(_faCalendarCheck.faCalendarCheck);

_fontawesomeSvgCore.library.add(_faCaretUp.faCaretUp);

_fontawesomeSvgCore.library.add(_faCaretDown.faCaretDown);

_fontawesomeSvgCore.library.add(_faTh.faTh);

_fontawesomeSvgCore.library.add(_faQuestion.faQuestion);

_fontawesomeSvgCore.library.add(_faSearch.faSearch);

_fontawesomeSvgCore.library.add(_faStar.faStar);

_fontawesomeSvgCore.library.add(_faPlus.faPlus);

_fontawesomeSvgCore.library.add(_faMinus.faMinus);

_fontawesomeSvgCore.library.add(_faExpand.faExpand);

_fontawesomeSvgCore.library.add(_faLocationArrow.faLocationArrow);